import React, { useEffect, useState } from 'react';
import { Drawer, List, ListItem, ListItemText, Toolbar, AppBar, Typography, IconButton,
  Divider, Box,Collapse,Button } from '@mui/material';
import SupplierStepper from './SupplierStepper';
import SupplierForm from './SupplierForm';
import SupplierFormView from './SupplierFormView';
import SupplierAddressForm from './SupplierAddressForm';
import CertificateForm from './CertificateForm';
import WarehouseForm from './WarehouseForm';
import ProductUpload from './ProductUpload'; 
import SupplierGuidelines from './SupplierGuidelines';
import { getSupplierInfo,saveSupplierInfo, getCompanyTypes, updateSupplierInfo } from '../service/supplierService'; // Service to call backend
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/SFooter';
import AddProduct from './SupplierAddProduct';
import SupplierVerifyProduct from './SupplierVerifyProduct';
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useTranslation } from 'react-i18next';
import certificateService from '../service/certificateService';
import warehouseService from '../service/warehouseService'; 
import addressService from '../service/addressService'; 
import FulfillmentOrderSupplier from './FulfillmentOrderSupplier';
const drawerWidth = 240;


export default function SupplierDashboard() {
  const [supplierExists, setSupplierExists] = useState(null); // null: loading, true: dashboard, false: stepper
  const [selectedMenu, setSelectedMenu] = useState('Dashboard');
  const { userSupplier , loginSupplier, logoutSupplier } = useAuth();
  const [supplierData, setSupplierData] = useState({
    supplierName: '',
    email: '',
    phone: '',
    contactPerson: '',
    gstNumber: '',
    panNumber: '',
    website: '',
    companyTypeId: '',
    addresses: [], 
    certificates: [],
    warehouses: [],
  });
  const navigate = useNavigate();
    const [open, setOpen] = useState(true);
      const { t } = useTranslation(); // i18n hook

  const toggleDrawer = () => {
    setOpen(!open);
  };
  
    const handleLogout = () => {
    logoutSupplier(); 
     navigate('/supplierlogin');

  };
    
  const {
    email,
    name,
    familyName,
    givenName,
    userId,
    roles, 
    userTypes,
    partnerId,
    emailVerified,
  } = userSupplier || {};
    
  useEffect(() => {
    
    console.log("supplier user ",userSupplier );
      console.log("supplier login ",loginSupplier );
    
    async function fetchSupplierData() {
      try {
        const response = await getSupplierInfo(email); 
        if (response && response.data) {
          setSupplierExists(true);
            console.log("supplier exist ",response.data );
          setSupplierData(response.data);
          
        } else {
          setSupplierExists(false);
        }
      } catch (error) {
        console.error('Error fetching supplier data:', error);
        setSupplierExists(false);
      }
    }
    fetchSupplierData();
  }, []);

  if (supplierExists === null) {
    return <div>Loading...</div>; 
  }
  
    const updateData = (key, value) => {
    setSupplierData(prev => ({ ...prev, [key]: value }));
  };

  if (!supplierExists) {
   // return <SupplierStepper />; // Supplier info not completed yet
      
       navigate('/suppliers');
  }
  
      const handleUpdate = async () => {
    try {
      console.log("dashboard : " , supplierData);
      await updateSupplierInfo(supplierData.supplierId, updateData);
      
        } catch (error) {
      console.error('Error saving supplier info:', error);
    }
  };
  
  
  const handleUpdateAddresses = async () => {   
    
    try {
      console.log("dashboard : " , supplierData);
  
        await addressService.saveAllSupplierAddresses(supplierData);
        } catch (error) {
      console.error('Error saving supplier info:', error);
    }
  };
  
    const handleUpdateCertificates = async () => {   
        try {
      console.log("dashboard : " , supplierData);
     // await updateSupplierInfo(supplierData.supplierId, supplierData);
      
        await certificateService.saveSupplierCertificate(supplierData);
        } catch (error) {
      console.error('Error saving supplier info:', error);
    }
  };
  
    const handleUpdateWarehouses = async () => {  
     
        try {
      console.log("dashboard : " , supplierData);
     // await updateSupplierInfo(supplierData.supplierId, supplierData);
      
        await warehouseService.saveSupplierWarehouse(supplierData);
        } catch (error) {
      console.error('Error saving supplier info:', error);
    }
  };
  

  // Supplier exists, show full dashboard
  const renderContent = () => {
    switch (selectedMenu) {
      case 'Supplier Info':
        return <SupplierFormView data={supplierData} updateData={updateData} mode="dashboard" />;
      case 'Addresses':
        return <SupplierAddressForm data={supplierData.addresses} updateData={value => updateData('addresses', value)} handleSave={handleUpdateAddresses} mode="dashboard" supplierID={supplierData} />;
      case 'Certificates':
        return <CertificateForm data={supplierData.certificates} updateData={value => updateData('certificates', value)} handleSave={handleUpdateCertificates} mode="dashboard" />;
      case 'Warehouses':
        return <WarehouseForm data={supplierData.warehouses} updateData={value => updateData('warehouses', value)} handleSave={handleUpdateWarehouses}  mode="dashboard" />;
      case 'Product Upload':
        return <ProductUpload supplierId={supplierData.supplierId}/>;
      case 'Add Product':
        return <AddProduct data={supplierData} />;
      case 'Verify Product Upload':
        return <SupplierVerifyProduct data={supplierData} />;
      case 'FulfillmentOrder':
        return <FulfillmentOrderSupplier  data={supplierData.warehouses} />;
      default:
        return <SupplierGuidelines setSelectedMenu={setSelectedMenu} />;
    }
  };

  return (

   <>
  <AppBar position="static" sx={{ bgcolor: '#4D7B2B', color: '#FFFFFF' }}>
  <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
    {/* Title */}
    <Typography variant="h6" component="div">
      {selectedMenu === "Dashboard" ? "Dashboard" : selectedMenu}
    </Typography>

    <Box
            component="img"
            src="../images/foodsakzsidegraylogo.png" 
            alt="FoodSakz Logo"  
            sx={{ 
              height: 60,
              cursor: "pointer",
            }}
            onClick={() => navigate("/supplierdashboard")}
           />
  </Toolbar>
</AppBar>
        <Box sx={{ display: "flex", minHeight: "100vh", flexDirection: "column" }}>
  

<Box sx={{ display: "flex" }}>
      {/* Sidebar with toggle arrow */}
      <Collapse in={open} orientation="horizontal">
        <Box
          sx={{
            width: 250,
            borderRight: "1px solid #ddd",
            position: "relative",
            backgroundColor: "#fafafa",
            height: "100vh"
          }}
        >
         {/* Drawer */}
  <Drawer
    variant="persistent"
    anchor="left"
    open={open}
    sx={{
      width: drawerWidth,
      flexShrink: 0,
      "& .MuiDrawer-paper": {
        width: drawerWidth,
        boxSizing: "border-box",
        top: { xs: "56px", sm: "64px" }, // below AppBar
        height: { xs: "calc(100% - 56px)", sm: "calc(100% - 64px)" }
      }
    }}
  >
    <Typography variant="h6" component="div">
        Welcome {name}
    </Typography>
    <Button variant="outlined" color="inherit" onClick={handleLogout} 
              
                sx={{
                  marginTop: 2,
                  backgroundColor: '#F1B94C',
                  color: '#2C2E2F',
                  fontWeight: 'semibold',
                  '&:hover': {
                    backgroundColor: '#49A39D',
                  },
                }}
>
          Logout
        </Button>
    <Divider />
        <List>
          {['Dashboard', 'Supplier Info', 'Addresses', 'Certificates', 'Warehouses', 'Product Upload', 'Add Product', 'Verify Product Upload','FulfillmentOrder'].map((text) => (
            <ListItem button key={text} onClick={() => setSelectedMenu(text)}>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List>
      </Drawer>

          {/* Arrow button inside sidebar */}
          <IconButton
            onClick={toggleDrawer}
            sx={{
              position: "absolute",
              top: "50%",
              right: -20,
              transform: "translateY(-50%)",
              backgroundColor: "white",
              border: "1px solid #ccc",
              "&:hover": { backgroundColor: "#f0f0f0" }
            }}
            size="small"
          >
            <ChevronLeftIcon />
          </IconButton>
        </Box>
      </Collapse>

      {/* Collapsed toggle button */}
      {!open && (
        <IconButton
          onClick={toggleDrawer}
          sx={{
            position: "relative",
            backgroundColor: "white",
            border: "1px solid #ccc",
            height: "40px",
            marginTop: "20px",
            "&:hover": { backgroundColor: "#f0f0f0" }
          }}
          size="small"
        >
          <ChevronRightIcon />
        </IconButton>
      )}
      <Box component="main"  sx={{
              flexGrow: 1,
              p: 3,
              transition: "margin 0.3s",
              marginLeft: open ? `${drawerWidth}px` : "0px",
            }}>
        <Toolbar />
        {renderContent()}
      </Box>
    </Box>
           <Footer />
     </Box>
</>
     
  );
}